var map = {
	"./404.svg": "sEM+",
	"./btn.svg": "O+kw",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./gongdan.svg": "CjbA",
	"./gongyi.svg": "VBuR",
	"./huishou.svg": "xonu",
	"./huodong.svg": "+bD3",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./jiedao.svg": "/LpQ",
	"./jifen.svg": "LetU",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./lock.svg": "FnAU",
	"./mail.svg": "CFfD",
	"./menu.svg": "dH9r",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./neirong.svg": "DUwT",
	"./nested.svg": "798r",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./plus-activity.svg": "389u",
	"./qq.svg": "R2jY",
	"./quanxian.svg": "mwRM",
	"./question.svg": "noTa",
	"./shezhi.svg": "rDgv",
	"./shoppingCard.svg": "dNDk",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./trendChart1.svg": "b9BN",
	"./trendChart2.svg": "rlTB",
	"./trendChart3.svg": "4m33",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./yg-guanli.svg": "Pzvj",
	"./yonghu.svg": "qRd6",
	"./zhandian.svg": "YfI1",
	"./zhengzhi.svg": "lfKU",
	"./zip.svg": "0DNV",
	"./zixun.svg": "ZkJM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 22